import React from "react";

import { getLanguageOptions } from "ui-kit/FieldTypes/utils";

import { Dropdown } from "ui-kit/Form/View";

import { getField } from "../../utils";

const Languages = props => {
  const { width = "100%" } = props || {};
  const options = getLanguageOptions();
  const field = getField(props);

  return (
    <Dropdown
      class="fieldTypes-languages_dropdown"
      multipleSelect={true}
      iniValue={props.iniValue}
      options={options}
      disabled={props.disabled}
      fieldId={field.id || props.fieldId}
      instanceId={props.instanceId}
      width={width}
    />
  );
};

export default Languages;
